import SecurityApi from "./security.api";

const IPQS = "/ip/ipqs";
SecurityApi.init();
class SecurityService {
  static async getIP() {
    try {
      const response = await SecurityApi.get(`/v1${IPQS}/info`);
      return response?.ipAddress ?? null;
    } catch (e) {
      console.error(e);
    }
  }
  static async getIPDetails(ip) {
    try {
      const response = await SecurityApi.get(`/v1${IPQS}/${ip}`);
      return response?.ipAddress ?? null;
    } catch (e) {
      console.error(e);
    }
  }
}

export default SecurityService;
